import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e7f73c2c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e7f73c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f73c2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7f73c2c')) {
      api.createRecord('e7f73c2c', component.options)
    } else {
      api.reload('e7f73c2c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e7f73c2c&scoped=true&", function () {
      api.rerender('e7f73c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eJJdLrnD9b5Y/JS/comp/PopupBox.vue"
export default component.exports